export default function PHP_Exercises() {
  return (
    <div>
      <h1>PHP_Exercises</h1>
    </div>
  );
}
